import AppHeaderService from "../../services/AppHeader.service";
//import ScheduleService from "../../services/schedule.service";

const state = {
    NotifyDetails: [],
    NewNotifies: [],
    OldNotifies: [],
    Notifies:[],
    idOfPdf: 0,
    isActiveNotifyDetails: false,
    FKeyForZip: null,
};

const mutations = {

    set_notify_details(state,payload)
    {
        state.NotifyDetails = payload;
    },
    set_new_notifies(state,payload)
    {
        state.NewNotifies = payload;
    }

};

const actions = {

        async GetNewNotifies({commit},LastId) {
        //console.log("module lastid: "+LastId);

        const notifies = await AppHeaderService.GetNewNotifiesByLastId(LastId);
        await commit("set_new_notifies", notifies);
        // dispatch("getDailyFlightSummary");
        // console.log("notifies module");


        return notifies

    },

    async GetNotifyDetails({commit},SummaryId) {

        //console.log("Summary Id appheader module" + SummaryId);

        const NotifyDetails = await AppHeaderService.GetNotifiesOfSummary(SummaryId);
        await commit("set_notify_details",NotifyDetails);

        return NotifyDetails;

    },

    // async getScheduleFlights({commit, dispatch}) {
    //
    //     const schedule = await ScheduleService.getScheduleFlights(state.SearchDate);
    //     await commit("set_flight_list", schedule);
    //     dispatch("getDailyFlightSummary");
    //     return schedule
    // },

    // async getScheduleChangeFlights({commit, dispatch}) {
    //
    //     const timeSpan = await ScheduleService.getFlightsTimeSpan(state.SearchDate);
    //
    //     if (typeof timeSpan.dTutc !== "undefined")
    //     {
    //         //console.log("undefined filtresi " + timeSpan.dTutc);
    //         commit("set_DbDTutc",timeSpan.dTutc);
    //     }
    //
    //     if (timeSpan.count != state.timeSpan)
    //     {
    //         const schedule = await ScheduleService.getScheduleFlights(state.SearchDate);
    //         await commit("set_flight_change_list", schedule);
    //         commit("set_timeSpan", timeSpan.count);
    //         dispatch("getDailyFlightSummary");
    //         return schedule;
    //     }
    //
    // },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
